<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <SearchSaDetailForm :propsSaNo="saNo" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SearchSaDetailForm from '@/components/organisms/terminal/form/SearchSaDetailForm'

export default {
  name: 'SearchSaDetailPage',

  components: {
    SearchSaDetailForm,
  },

  data() {
    return {
      saNo: '',
    }
  },

  created() {
    const query = this.$route.query
    if (query.saNo) {
      this.saNo = query.saNo
    }
  },
}
</script>
